import { useParams } from 'react-router';

import { AxiosResponse } from 'axios';
import { FormikHelpers } from 'formik';
import { enqueueSnackbar } from 'notistack';

import { useFormContext } from 'context/FormContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import useNavigateBack from 'hooks/useNavigateBack';
import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useColunasDinamicasContext } from 'pages/cadastro/colunas-dinamicas/contexts/ColunasDinamicasContext';
import { ColunaDinamicaProps } from 'pages/cadastro/loja/types';

export function useMutateColunasDinamicas() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<ColunaDinamicaProps[]>>();
    const { showError } = useShowError();
    const { id } = useParams();
    const { hasPermission } = usePermissionsContext();
    const { setContent } = useFormContext();
    const { setOpenModalColunasDinamicas } = useColunasDinamicasContext();

    const navigateBack = useNavigateBack();

    const onSubmitForm = (formData: ColunaDinamicaProps, formik?: FormikHelpers<ColunaDinamicaProps>) => {
        let url = `/gestao/configuracaopropriedade/ordenado?fgReordena=${Boolean(formData?.fgReordena)}`;

        if (id) {
            url = `/gestao/configuracaopropriedade/${id}/ordenado?fgReordena=${Boolean(formData?.fgReordena)}`;
        }

        mutate(
            {
                url,
                formData,
                formik,
                method: id ? 'PUT' : 'POST',
                preventSnack: true,
                preventRedirect: !!hasPermission(['LOJA_ALTERAR']),
            },
            {
                onSuccess: (data: AxiosResponse<any>) => {
                    enqueueSnackbar('Coluna salva com sucesso', { variant: 'success' });
                    const novoContent = data.data?.data || [];

                    setContent(novoContent);

                    if (!id) {
                        navigateBack();
                    }
                },
                onError: (error: any) => {
                    showError(error, 'Erro ao salvar coluna');

                    setOpenModalColunasDinamicas(true);
                },
            },
        );
    };

    return { onSubmitForm, isLoading };
}
